import Box from "@mui/material/Box";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import { useUpdateGameStatusQuery } from "entities/game/queries/useUpdateGameStatusQuery";
import React from "react";
import DropdownList from "shared/components/DropdownList";
import { useGameDetails } from "../../context";
import { StyledButton } from "../../styled";

const ActionButton = () => {
  const {
    gameDetails: game,
    onSaveGameDetails,
    isSubmittingGame,
    onSaveGameTranslations,
  } = useGameDetails();
  const { mutate } = useUpdateGameStatusQuery();

  const handleChangeStatus = () => {
    if (game?.id) {
      mutate({
        gameId: game?.id.toString(),
        status: !game.isActive,
      });
    }
  };

  const statusTitle = game?.isActive ? "Deactivate" : "Activate";

  const { allowed: hasWriteAccess } = useRolePermission("games:write");
  const { allowed: hasWriteTranslationsAccess } = useRolePermission(
    "games:translations:write",
  );

  if (!hasWriteAccess && !hasWriteTranslationsAccess) {
    return null;
  }

  if (!hasWriteAccess && hasWriteTranslationsAccess) {
    return (
      <Box>
        <StyledButton
          title="Save"
          size="small"
          onClick={onSaveGameTranslations}
          loading={isSubmittingGame}
        />
      </Box>
    );
  }

  return (
    <Box>
      <StyledButton
        title="Save"
        size="small"
        onClick={onSaveGameDetails}
        loading={isSubmittingGame}
      />
      <DropdownList
        items={[
          {
            title: statusTitle,
            onClick: handleChangeStatus,
          },
        ]}
      />
    </Box>
  );
};

export default ActionButton;
